// theme-sources/js/core-ui/components/sticky-header.js

import { sectionLogger } from "./_logger";

const DEBUG = false;
const logger = sectionLogger("StickyHeader", DEBUG);

const SCOPE = "StickyHeader";

class StickyHeader extends HTMLElement {
  connectedCallback() {
    this.header = document.querySelector(".section-header");
    if (!this.header) {
      logger.warn(SCOPE, "no .section-header found");
      return;
    }

    this.headerIsAlwaysSticky =
      this.dataset.stickyType === "always" ||
      this.dataset.stickyType === "reduce-logo-size";

    this.headerBounds = {};
    this.currentScrollTop = 100;
    this.preventReveal = false;

    this.setHeaderHeight = this.setHeaderHeight.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.setHeaderHeight();
    this.createObserver();

    window
      .matchMedia("(max-width: 1024px)")
      .addEventListener("change", this.setHeaderHeight);

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add("shopify-section-header-sticky");
    }

    this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.addEventListener("scroll", this.onScroll, { passive: true });

    logger.info(SCOPE, "connected");
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScroll);
    this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty(
      "--header-height",
      `${this.header.offsetHeight}px`,
    );
  }

  createObserver() {
    const observer = new IntersectionObserver((entries, obs) => {
      this.headerBounds = entries[0].intersectionRect;
      obs.disconnect();
    });
    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.scrollY;

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.header.classList.add("scrolled-past-header");
      requestAnimationFrame(() => this.hide());
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.header.classList.add("scrolled-past-header");
      if (!this.preventReveal) {
        requestAnimationFrame(() => this.reveal());
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove("scrolled-past-header");
      requestAnimationFrame(() => this.reset());
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add(
      "shopify-section-header-hidden",
      "shopify-section-header-sticky",
    );
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add("shopify-section-header-sticky", "animate");
    this.header.classList.remove("shopify-section-header-hidden");
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove(
      "shopify-section-header-hidden",
      "shopify-section-header-sticky",
      "animate",
    );
  }
}

if (!customElements.get("sticky-header")) {
  customElements.define("sticky-header", StickyHeader);
}
